<template>
  <div
    class="min-w-[250px] max-w-[250px] bg-zinc-900 rounded-lg overflow-hidden shadow hover:scale-[1.03] transition-transform cursor-pointer"
  >
    <div class="relative aspect-video">
      <img 
        :src="image" 
        alt="Evento" 
        class="w-full h-full object-cover" 
      />
      <!-- <span
        v-if="live"
        class="absolute top-2 left-2 bg-red-600 text-white text-xs px-2 py-1 rounded uppercase font-bold"
      >
        AO VIVO
      </span> -->
    </div>

    <div class="p-3 text-white">
      <p class="text-sm text-gray-400 mb-1">{{ tag }}</p>
      <h3 class="text-2xl tracking-wide font-semibold text-white leading-tight">
        {{ title.length > 60 ? title.slice(0, 60).concat("...") : title }}
      </h3>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  image: {
    type: String,
    default: "https://via.placeholder.com/320x180.png?text=Evento",
  },
  title: {
    type: String,
    default: "Título do Evento",
  },
  tag: {
    type: String,
    required: false,
  },
  live: {
    type: Boolean,
    default: false,
  },
});
</script>
